export default "__VITE_PUBLIC_ASSET__841cbb44__"